import React, { useState, useEffect, useMemo, useContext } from 'react';
import { CrudMasterDetailView, GridView, CrudContext, CompositeView, notification, Widget, Table, ColumnProps } from '@digital/ui';
import { Card, Col, Divider, Row, Tooltip } from 'antd';
import './custom.css';
import { InformacaoProjetoResult, Metas } from '@app/api/tabelaProjetoOverView';
import GraficoProjectsOverview from '@app/views/Dashboard/ProjectsOverview/graficoProjectsOverview';
import { Projeto } from '@app/api/projeto';
import StatusCircle from '@app/components/statusCircle';
import PerfectScrollbar from 'react-perfect-scrollbar';

interface ProjetoOverViewProps {
  selectedItem: Projeto;
}

const ProjetoOverView = ({ selectedItem }: ProjetoOverViewProps) => {
  const [informacaoProjeto, setInformacaoProjeto] = useState<InformacaoProjetoResult>();

  useEffect(() => {
    setInformacaoProjeto({
      projetoId: selectedItem.id,
      cicloAno: selectedItem.informacaoProjetoResult ? selectedItem.informacaoProjetoResult.cicloAno : '',
      scope: selectedItem.escopoPluriAnual,
      metas: selectedItem.informacaoProjetoResult ? selectedItem.informacaoProjetoResult.metas : [],
      overView: selectedItem.informacaoProjetoResult ? selectedItem.informacaoProjetoResult.overView : [],
      graficoCiloAno: selectedItem.informacaoProjetoResult ? selectedItem.informacaoProjetoResult.graficoCiloAno : undefined,
      graficoPluriAnual: selectedItem.informacaoProjetoResult ? selectedItem.informacaoProjetoResult.graficoPluriAnual : undefined,
    } as InformacaoProjetoResult);
  }, [selectedItem])

  const collunsTabelaProjetoGoals = () => {
    const col: ColumnProps<Metas>[] = [
      {
        dataIndex: 'descricao',

      },
      {
        title: 'Completion',
        dataIndex: 'completion',
        render: (text, row, index) => {
          return (row.completion != undefined && row.completion != '' ? <StatusCircle noPrazo={row.statusCompletion} valorLabel={row.completion} /> : <> </>)
        }
      },
      {

        title: 'CapEx (R$)',
        dataIndex: 'capEx',
      },
    ];

    return col;
  }

  const collunsTabelaProjetoOverView = () => {
    const col: ColumnProps<any>[] = [
      {

        title: 'PROGRESS',
        dataIndex: 'progress',

      },
      {
        align: 'center',
        title: 'Economical Progress',
        children: [
          {
            title: 'Plan',
            dataIndex: 'economicProgrPlan',
            render: (text, row, index) => {
              return (
                <>
                  <Tooltip title={row.economicProgrPlanDescricao}>
                    <span>{row.economicProgrPlan}</span>
                  </Tooltip>
                </>
              )
            }

          },
          {
            title: 'Actual',
            dataIndex: 'economicProgrActual',
            render: (text, row, index) => {
              return (
                <>
                  <Tooltip title={row.economicProgrActualDescricao}>
                    <span>{row.economicProgrActual}</span>
                  </Tooltip>
                </>
              )
            }

          },
          {
            title: 'AdEc',
            dataIndex: 'economicProgrAdEc',
            render: (text, row, index) => {
              return (
                <>
                  <Tooltip title={row.economicProgrAdEcDescricao}>
                    <span>{row.economicProgrAdEc}</span>
                  </Tooltip>
                </>
              )
            }

          },
        ]
      }
    ];

    return col;
  }

  return (
    <>
      <Widget>

        <Row className="overview-row">

          <Col span={24}>
            <div className="site-card-border-less-wrapper">
              <Card title="SCOPE" bordered={false}>
                <p>{informacaoProjeto ? informacaoProjeto.scope : ''}</p>
              </Card>
            </div>
          </Col>


        </Row>

        <Divider />
        <Row>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <div className="site-card-border-less-wrapper">
              {/* <Card title="GOALS" bordered={false} style={{ height: 250 }}> */}
              <Card title="GOALS" bordered={false}>
                <PerfectScrollbar>
                  <Table
                    rowKey="id"
                    columns={collunsTabelaProjetoGoals()}
                    dataSource={informacaoProjeto ? informacaoProjeto.metas : []}
                    pagination={false}
                  />
                </PerfectScrollbar>
              </Card>
            </div>
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
         
            <div className="site-card-border-less-wrapper">
              {/* <Card title="OVERVIEW" bordered={false} style={{ height: 250 }} > */}
              <Card title="OVERVIEW" bordered={false}>
                <PerfectScrollbar>
                  <Table
                    rowKey="id"
                    columns={collunsTabelaProjetoOverView()}
                    dataSource={informacaoProjeto ? informacaoProjeto.overView : []}
                    pagination={false}
                  />
                </PerfectScrollbar>
              </Card>
            </div>
          </Col>

        </Row>
      </Widget>

      <Widget>

        <Row>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <div className="site-card-border-less-wrapper">
              <Card
                bordered={false}>
                {informacaoProjeto && informacaoProjeto.graficoCiloAno ? (
                  <GraficoProjectsOverview
                    graficoRpp={informacaoProjeto.graficoCiloAno}
                    tituloGrafico={`CONTROLE DO ORÇAMENTO ${informacaoProjeto.cicloAno}`}
                  />) : (<> </>)}
              </Card>
            </div>
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <div className="site-card-border-less-wrapper">
              <Card bordered={false} >
                {informacaoProjeto && informacaoProjeto.graficoPluriAnual ? (
                  <GraficoProjectsOverview
                    graficoRpp={informacaoProjeto.graficoPluriAnual}
                    tituloGrafico={'CONTROLE DO ORÇAMENTO PLURIANUAL'}
                  />
                ) : (<> </>)}
              </Card>
            </div>
          </Col>

        </Row>
      </Widget>
    </>

  );
};

export default ProjetoOverView;
